var map = {
	"./$pac.svg": 54863,
	"./0xbtc.svg": 18076,
	"./1inch.svg": 99844,
	"./2give.svg": 18664,
	"./aave.svg": 73994,
	"./abt.svg": 69138,
	"./act.svg": 59333,
	"./actn.svg": 44537,
	"./ada.svg": 16773,
	"./add.svg": 85368,
	"./adx.svg": 67612,
	"./ae.svg": 86797,
	"./aeon.svg": 46550,
	"./aeur.svg": 46180,
	"./agi.svg": 77956,
	"./agrs.svg": 81934,
	"./aion.svg": 60002,
	"./algo.svg": 93214,
	"./amb.svg": 56893,
	"./amp.svg": 30591,
	"./ampl.svg": 56457,
	"./ankr.svg": 3153,
	"./ant.svg": 25910,
	"./ape.svg": 83741,
	"./apex.svg": 83695,
	"./appc.svg": 66643,
	"./ardr.svg": 78988,
	"./arg.svg": 73665,
	"./ark.svg": 92117,
	"./arn.svg": 18184,
	"./arnx.svg": 7056,
	"./ary.svg": 85847,
	"./ast.svg": 33621,
	"./atlas.svg": 42224,
	"./atm.svg": 1985,
	"./atom.svg": 52748,
	"./audr.svg": 77779,
	"./aury.svg": 3958,
	"./auto.svg": 9286,
	"./avax.svg": 23249,
	"./aywa.svg": 24685,
	"./bab.svg": 10554,
	"./bal.svg": 77548,
	"./band.svg": 29150,
	"./bat.svg": 78868,
	"./bay.svg": 37633,
	"./bcbc.svg": 77567,
	"./bcc.svg": 93029,
	"./bcd.svg": 15578,
	"./bch.svg": 70254,
	"./bcio.svg": 19610,
	"./bcn.svg": 32800,
	"./bco.svg": 68753,
	"./bcpt.svg": 31430,
	"./bdl.svg": 30859,
	"./beam.svg": 45570,
	"./bela.svg": 43753,
	"./bix.svg": 58936,
	"./blcn.svg": 55994,
	"./blk.svg": 31020,
	"./block.svg": 47474,
	"./blz.svg": 66973,
	"./bnb.svg": 94191,
	"./bnt.svg": 56401,
	"./bnty.svg": 67546,
	"./booty.svg": 64640,
	"./bos.svg": 9313,
	"./bpt.svg": 40551,
	"./bq.svg": 5272,
	"./brd.svg": 49789,
	"./bsd.svg": 31850,
	"./bsv.svg": 16184,
	"./btc.svg": 44956,
	"./btcd.svg": 80360,
	"./btch.svg": 67932,
	"./btcp.svg": 31748,
	"./btcz.svg": 60142,
	"./btdx.svg": 69025,
	"./btg.svg": 58096,
	"./btm.svg": 31402,
	"./bts.svg": 86572,
	"./btt.svg": 20467,
	"./btx.svg": 35543,
	"./burst.svg": 70223,
	"./bze.svg": 26292,
	"./call.svg": 35551,
	"./cc.svg": 80493,
	"./cdn.svg": 12600,
	"./cdt.svg": 15186,
	"./cenz.svg": 99415,
	"./chain.svg": 74670,
	"./chat.svg": 35693,
	"./chips.svg": 11688,
	"./chsb.svg": 69977,
	"./chz.svg": 43984,
	"./cix.svg": 58061,
	"./clam.svg": 82656,
	"./cloak.svg": 26405,
	"./cmm.svg": 80116,
	"./cmt.svg": 9805,
	"./cnd.svg": 10292,
	"./cnx.svg": 81920,
	"./cny.svg": 38833,
	"./cob.svg": 37801,
	"./colx.svg": 23061,
	"./comp.svg": 8066,
	"./coqui.svg": 472,
	"./cred.svg": 60807,
	"./crpt.svg": 80304,
	"./crv.svg": 7162,
	"./crw.svg": 21771,
	"./cs.svg": 29405,
	"./ctr.svg": 69132,
	"./ctxc.svg": 61929,
	"./cvc.svg": 33795,
	"./d.svg": 94189,
	"./dai.svg": 74339,
	"./dash.svg": 60883,
	"./dat.svg": 8038,
	"./data.svg": 19659,
	"./dbc.svg": 52044,
	"./dcn.svg": 39434,
	"./dcr.svg": 21902,
	"./deez.svg": 74859,
	"./dent.svg": 21916,
	"./dew.svg": 15545,
	"./dgb.svg": 16090,
	"./dgd.svg": 26020,
	"./dlt.svg": 54485,
	"./dnt.svg": 50895,
	"./dock.svg": 83618,
	"./doge.svg": 77552,
	"./dot.svg": 18956,
	"./drgn.svg": 88310,
	"./drop.svg": 41320,
	"./dta.svg": 42256,
	"./dth.svg": 23289,
	"./dtr.svg": 4627,
	"./ebst.svg": 35255,
	"./eca.svg": 25460,
	"./edg.svg": 6631,
	"./edo.svg": 95951,
	"./edoge.svg": 33571,
	"./ela.svg": 3889,
	"./elec.svg": 58772,
	"./elf.svg": 94894,
	"./elix.svg": 34019,
	"./ella.svg": 5069,
	"./emb.svg": 51969,
	"./emc.svg": 39728,
	"./emc2.svg": 86402,
	"./eng.svg": 48561,
	"./enj.svg": 31908,
	"./entrp.svg": 97780,
	"./eon.svg": 99311,
	"./eop.svg": 14377,
	"./eos.svg": 53210,
	"./eqli.svg": 7912,
	"./equa.svg": 91023,
	"./etc.svg": 65035,
	"./eth.svg": 51296,
	"./ethos.svg": 37030,
	"./etn.svg": 88750,
	"./etp.svg": 8968,
	"./eur.svg": 66121,
	"./evx.svg": 63710,
	"./exmo.svg": 39524,
	"./exp.svg": 63716,
	"./fair.svg": 82245,
	"./fct.svg": 47374,
	"./fida.svg": 37105,
	"./fil.svg": 10904,
	"./fjc.svg": 11606,
	"./fldc.svg": 94326,
	"./flo.svg": 95564,
	"./flux.svg": 37282,
	"./fsn.svg": 95268,
	"./ftc.svg": 896,
	"./fuel.svg": 21939,
	"./fun.svg": 12246,
	"./game.svg": 76169,
	"./gas.svg": 10666,
	"./gbp.svg": 35776,
	"./gbx.svg": 98776,
	"./gbyte.svg": 68472,
	"./generic.svg": 42586,
	"./gin.svg": 27351,
	"./glxt.svg": 37938,
	"./gmr.svg": 23303,
	"./gmt.svg": 67449,
	"./gno.svg": 40219,
	"./gnt.svg": 22752,
	"./gold.svg": 41213,
	"./grc.svg": 22419,
	"./grin.svg": 63213,
	"./grs.svg": 74563,
	"./grt.svg": 76636,
	"./gsc.svg": 32752,
	"./gto.svg": 87989,
	"./gup.svg": 95517,
	"./gusd.svg": 40046,
	"./gvt.svg": 71944,
	"./gxs.svg": 53253,
	"./gzr.svg": 70778,
	"./hight.svg": 16989,
	"./hns.svg": 17092,
	"./hodl.svg": 88892,
	"./hot.svg": 73704,
	"./hpb.svg": 2963,
	"./hsr.svg": 60202,
	"./ht.svg": 31879,
	"./html.svg": 17924,
	"./huc.svg": 72121,
	"./husd.svg": 73463,
	"./hush.svg": 58387,
	"./icn.svg": 48279,
	"./icp.svg": 90017,
	"./icx.svg": 19161,
	"./ignis.svg": 4755,
	"./ilk.svg": 24783,
	"./ink.svg": 45961,
	"./ins.svg": 78081,
	"./ion.svg": 51547,
	"./iop.svg": 77357,
	"./iost.svg": 19182,
	"./iotx.svg": 61195,
	"./iq.svg": 71529,
	"./itc.svg": 86783,
	"./jnt.svg": 41542,
	"./jpy.svg": 18586,
	"./kcs.svg": 12380,
	"./kin.svg": 20891,
	"./klown.svg": 11866,
	"./kmd.svg": 40805,
	"./knc.svg": 37571,
	"./krb.svg": 27694,
	"./ksm.svg": 69514,
	"./lbc.svg": 68260,
	"./lend.svg": 74820,
	"./leo.svg": 72473,
	"./link.svg": 39343,
	"./lkk.svg": 65191,
	"./loom.svg": 90360,
	"./lpt.svg": 4737,
	"./lrc.svg": 7380,
	"./lsk.svg": 60799,
	"./ltc.svg": 88842,
	"./lun.svg": 56216,
	"./maid.svg": 63374,
	"./mana.svg": 79490,
	"./matic.svg": 63531,
	"./max.svg": 42719,
	"./mcap.svg": 61204,
	"./mco.svg": 95642,
	"./mda.svg": 48241,
	"./mds.svg": 47011,
	"./med.svg": 98991,
	"./meetone.svg": 47638,
	"./mft.svg": 28338,
	"./miota.svg": 90301,
	"./mith.svg": 72001,
	"./mkr.svg": 14295,
	"./mln.svg": 69278,
	"./mnx.svg": 2926,
	"./mnz.svg": 52332,
	"./moac.svg": 3395,
	"./mod.svg": 42397,
	"./mona.svg": 26084,
	"./msr.svg": 64447,
	"./mth.svg": 65896,
	"./mtl.svg": 90516,
	"./music.svg": 5352,
	"./mzc.svg": 28313,
	"./nano.svg": 70801,
	"./nas.svg": 47679,
	"./nav.svg": 97378,
	"./ncash.svg": 94710,
	"./ndz.svg": 5393,
	"./nebl.svg": 74098,
	"./neo.svg": 53567,
	"./neos.svg": 13182,
	"./neu.svg": 76757,
	"./nexo.svg": 46567,
	"./ngc.svg": 66725,
	"./nio.svg": 58499,
	"./nkn.svg": 99044,
	"./nlc2.svg": 40274,
	"./nlg.svg": 91532,
	"./nmc.svg": 41091,
	"./nmr.svg": 15842,
	"./npxs.svg": 18118,
	"./ntbc.svg": 85144,
	"./nuls.svg": 95607,
	"./nxs.svg": 51524,
	"./nxt.svg": 13675,
	"./oax.svg": 86793,
	"./ok.svg": 96049,
	"./omg.svg": 60706,
	"./omni.svg": 78344,
	"./one.svg": 96457,
	"./ong.svg": 427,
	"./ont.svg": 13736,
	"./oot.svg": 48011,
	"./ost.svg": 52407,
	"./ox.svg": 91506,
	"./oxt.svg": 94850,
	"./oxy.svg": 62071,
	"./part.svg": 22552,
	"./pasc.svg": 70468,
	"./pasl.svg": 82163,
	"./pax.svg": 2198,
	"./paxg.svg": 79605,
	"./pay.svg": 49063,
	"./payx.svg": 63837,
	"./pink.svg": 89403,
	"./pirl.svg": 88408,
	"./pivx.svg": 32096,
	"./plr.svg": 55383,
	"./poa.svg": 21549,
	"./poe.svg": 76305,
	"./polis.svg": 37200,
	"./poly.svg": 42449,
	"./pot.svg": 55056,
	"./powr.svg": 59803,
	"./ppc.svg": 86138,
	"./ppp.svg": 70105,
	"./ppt.svg": 99381,
	"./pre.svg": 8974,
	"./prl.svg": 23703,
	"./pungo.svg": 27294,
	"./pura.svg": 8417,
	"./qash.svg": 98088,
	"./qiwi.svg": 69957,
	"./qlc.svg": 18351,
	"./qnt.svg": 82438,
	"./qrl.svg": 8602,
	"./qsp.svg": 71273,
	"./qtum.svg": 50174,
	"./r.svg": 23811,
	"./rads.svg": 14783,
	"./rap.svg": 17144,
	"./ray.svg": 24273,
	"./rcn.svg": 61968,
	"./rdd.svg": 19683,
	"./rdn.svg": 39225,
	"./ren.svg": 51354,
	"./rep.svg": 97468,
	"./repv2.svg": 57700,
	"./req.svg": 68093,
	"./rhoc.svg": 18703,
	"./ric.svg": 32979,
	"./rise.svg": 42468,
	"./rlc.svg": 96180,
	"./rpx.svg": 81971,
	"./rub.svg": 30814,
	"./rvn.svg": 24723,
	"./ryo.svg": 93191,
	"./safe.svg": 80740,
	"./safemoon.svg": 43119,
	"./sai.svg": 37524,
	"./salt.svg": 19671,
	"./san.svg": 98875,
	"./sand.svg": 21613,
	"./sbd.svg": 1608,
	"./sberbank.svg": 63099,
	"./sc.svg": 99869,
	"./ser.svg": 51739,
	"./shift.svg": 89353,
	"./sib.svg": 70039,
	"./sin.svg": 38611,
	"./skl.svg": 89483,
	"./sky.svg": 81622,
	"./slr.svg": 10452,
	"./sls.svg": 55381,
	"./smart.svg": 25250,
	"./sngls.svg": 70320,
	"./snm.svg": 13325,
	"./snt.svg": 26164,
	"./snx.svg": 85904,
	"./soc.svg": 32776,
	"./sol.svg": 99375,
	"./spacehbit.svg": 18066,
	"./spank.svg": 73990,
	"./sphtx.svg": 56446,
	"./srn.svg": 19682,
	"./stak.svg": 35846,
	"./start.svg": 41713,
	"./steem.svg": 13049,
	"./storj.svg": 60129,
	"./storm.svg": 46750,
	"./stox.svg": 21667,
	"./stq.svg": 27951,
	"./strat.svg": 25155,
	"./stx.svg": 67862,
	"./sub.svg": 75451,
	"./sumo.svg": 95075,
	"./sushi.svg": 56875,
	"./sys.svg": 49862,
	"./taas.svg": 56098,
	"./tau.svg": 20423,
	"./tbx.svg": 79639,
	"./tel.svg": 21394,
	"./ten.svg": 4688,
	"./tern.svg": 71258,
	"./tgch.svg": 45769,
	"./theta.svg": 59093,
	"./tix.svg": 8570,
	"./tkn.svg": 52290,
	"./tks.svg": 71655,
	"./tnb.svg": 34401,
	"./tnc.svg": 98864,
	"./tnt.svg": 6367,
	"./tomo.svg": 73960,
	"./tpay.svg": 16117,
	"./trig.svg": 94213,
	"./trtl.svg": 70349,
	"./trx.svg": 61095,
	"./tusd.svg": 72307,
	"./tzc.svg": 72964,
	"./ubq.svg": 6411,
	"./uma.svg": 95490,
	"./uni.svg": 66439,
	"./unity.svg": 12706,
	"./usd.svg": 63833,
	"./usdc.svg": 56584,
	"./usdt.svg": 24247,
	"./utk.svg": 88707,
	"./veri.svg": 59127,
	"./vet.svg": 38796,
	"./via.svg": 5981,
	"./vib.svg": 93886,
	"./vibe.svg": 3135,
	"./vivo.svg": 94857,
	"./vrc.svg": 40110,
	"./vrsc.svg": 85713,
	"./vtc.svg": 25232,
	"./vtho.svg": 84070,
	"./wabi.svg": 6392,
	"./wan.svg": 70127,
	"./waves.svg": 35579,
	"./wax.svg": 15985,
	"./wbtc.svg": 21287,
	"./wgr.svg": 24901,
	"./wicc.svg": 19101,
	"./wings.svg": 35429,
	"./wpr.svg": 17804,
	"./wtc.svg": 91825,
	"./x.svg": 43353,
	"./xas.svg": 93493,
	"./xbc.svg": 70888,
	"./xbp.svg": 26955,
	"./xby.svg": 28802,
	"./xcp.svg": 23304,
	"./xdn.svg": 76723,
	"./xem.svg": 27407,
	"./xin.svg": 80552,
	"./xlm.svg": 21448,
	"./xmcc.svg": 30288,
	"./xmg.svg": 57741,
	"./xmo.svg": 66917,
	"./xmr.svg": 95696,
	"./xmy.svg": 11784,
	"./xp.svg": 69227,
	"./xpa.svg": 90928,
	"./xpm.svg": 31188,
	"./xpr.svg": 53299,
	"./xrp.svg": 56315,
	"./xsg.svg": 37319,
	"./xtz.svg": 42239,
	"./xuc.svg": 42985,
	"./xvc.svg": 44860,
	"./xvg.svg": 6416,
	"./xzc.svg": 54064,
	"./yfi.svg": 57683,
	"./yoyow.svg": 32382,
	"./zcl.svg": 63610,
	"./zec.svg": 91959,
	"./zel.svg": 32832,
	"./zen.svg": 24738,
	"./zest.svg": 16665,
	"./zil.svg": 48508,
	"./zilla.svg": 24193,
	"./zrx.svg": 57537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65745;